// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"screen-4k"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 4L22 20L2 20L2 4L14 4L18 4L22 4Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 4V20L2 20L2 4L22 4Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10 15V12.4286M10 12.4286V9M10 12.4286H7C6.44772 12.4286 6 11.9809 6 11.4286V9M17 15V14.4015C17 14.2393 16.9213 14.0871 16.7889 13.9934L14 12.0195V11.9805L16.7889 10.0066C16.9213 9.91286 17 9.7607 17 9.59846V9M14 15V9","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Screen4KIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'screen-4k',
    ref,
    icon: element,
  },
));

Screen4KIcon.displayName = 'Screen4KIcon';

export default Screen4KIcon;
